import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface ValueCardProps {
  value: {
    id: number;
    icon: string;
    title: string;
    description: string;
    color: string;
  };
}

const ValueCard = ({ value }: ValueCardProps) => {
  const colorClasses = {
    primary: 'from-primary/20 to-primary/5 border-primary/30',
    secondary: 'from-secondary/20 to-secondary/5 border-secondary/30',
    accent: 'from-accent/20 to-accent/5 border-accent/30',
    success: 'from-success/20 to-success/5 border-success/30',
  };

  const iconColorClasses = {
    primary: 'text-primary',
    secondary: 'text-secondary',
    accent: 'text-accent',
    success: 'text-success',
  };

  return (
    <div className={`relative glassmorphic rounded-xl p-6 border bg-gradient-to-br ${colorClasses[value.color as keyof typeof colorClasses]} hover:shadow-premium transition-all duration-500 hover:-translate-y-2 group shadow-silver-glow hover:shadow-orange-glow-hover card-3d-glow`}>
      <div className="flex items-start gap-4">
        <div className={`flex-shrink-0 w-14 h-14 rounded-xl bg-gradient-to-br ${colorClasses[value.color as keyof typeof colorClasses]} flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
          <Icon name={value.icon as any} size={28} className={iconColorClasses[value.color as keyof typeof iconColorClasses]} />
        </div>
        <div className="flex-1">
          <h3 className="text-xl font-display font-bold text-foreground mb-3 group-hover:text-primary transition-colors duration-300">
            {value.title}
          </h3>
          <p className="text-sm text-muted-foreground leading-relaxed">
            {value.description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ValueCard;